const getters = {
  // Buscar se existem grupos de whatsapp com broadcast habilitado
  attendanceGroupWhatsAppBroadcastEnabledList(state) {
    return state.groupList.filter(
      (attendanceGroup) =>
        attendanceGroup.channel == 'whatsapp' &&
        attendanceGroup.broadcastEnabled,
    );
  },
  getAttendanceGroupName: (state) => (attendanceGroupId) => {
    const attendanceGroupFound = state.groupList.find(
      (attendanceGroup) => attendanceGroup.id == attendanceGroupId,
    );
    if (attendanceGroupFound == undefined) {
      return '';
    }
    return attendanceGroupFound.name;
  },
};

export default getters;
